import { render } from "./InvoiceBody.vue?vue&type=template&id=fc975e7c&scoped=true"
import script from "./InvoiceBody.vue?vue&type=script&lang=js"
export * from "./InvoiceBody.vue?vue&type=script&lang=js"

import "./InvoiceBody.vue?vue&type=style&index=0&id=fc975e7c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc975e7c"]])

export default __exports__